
export default {
  baseApiPath : 'https://api.yuyoupx.com',
  hostName:'https://sh5.yuyoupx.com/',
  ucServer: 'https://uc-auth.yuyoupx.com',
  ucApiPath: 'https://uc-api.yuyoupx.com',
  htmlToPdf: 'https://util.yuyoupx.com/html-to-pdf?url=',
  omoReport: 'https://omo-report.yuyoupx.com',
  pdfViewer: 'https://static-1259204813.cos.ap-guangzhou.myqcloud.com/pdfh5js/v1/pdfh5/pdf.html?file='
}



// WEBPACK FOOTER //
// ./src/lib/conf/index.js